export const findValueRange = (array: any[], attr: string, value: number): any => {
    return array.find((data) => {
        const range = data[attr].split('-');
        return (value >= Number(range[0])) && (value <= Number(range[1]))
    });
}